/** @format */

import QueryString from 'query-string';
import FilterOptions from './filter_options';

/**
 * This is responsible for parsing queries from searches and giving a value that can be loaded into the search
 * @param search
 * @returns {*}
 */

/**
 * If search is defined, split on our filter deliminator @
 * If we have more than one in our array remove the first element
 * iterate through our filters and get their default settings and parse their value
 * @param search string
 * @returns {*}
 */
const getFilters = search => {
    if (search) {
        var filterSearch = search.replace(/^([a-z0-9].*?)(\s@|$)/, '@');
        var filters = filterSearch.split('@');
        if (filterSearch.length > 1 && filters.length > 1) {
            filters.splice(0, 1);
            filters = Object.values(
                filters
                    .filter(filter => {
                        const name = filter.split(' ')[0];
                        const filter_option = FilterOptions()[name];
                        if (!filter_option || typeof filter_option.name == 'undefined') {
                            return false;
                        }

                        return true;
                    })
                    .map(filter => {
                        // Format is @name value value value
                        // Pull the name off the front
                        var name = filter.split(' ')[0];
                        // Create a string from the values by removing the first element
                        var value = filter.split(' ').splice(1).join(' ');
                        var filter_option = FilterOptions()[name];

                        filter_option.value = value;
                        return filter_option;
                    })
            );
            return filters;
        }
    }
    return [];
};

/**
 * If search is defined, remove just the first value without extra
 * @param search string
 * @returns {*}
 */
function getSearch(search) {
    if (typeof search != 'undefined') {
        var searchText = search.match(/^([a-z0-9].*?)(\s@|$)/i);
        if (searchText && searchText.length > 1) {
            return searchText[1].trim();
        }
    }

    return '';
}

const getQuery = searchStr => {
    if (typeof searchStr == 'undefined') {
        searchStr = window.location.search;
    }
    return QueryString.parse(searchStr);
};

const parseSearchQuery = searchStr => {
    const parsed = getQuery(searchStr);
    const raw_search = typeof parsed.search != 'undefined' ? parsed.search : '';
    const search = getSearch(parsed.search);
    const filters = getFilters(parsed.search);
    const sort = typeof parsed.sort != 'undefined' ? parsed.sort : '';
    const direction = typeof parsed.direction != 'undefined' ? parsed.direction : '';

    return {
        raw_search,
        search,
        filters,
        sort,
        direction
    };
};

/**
 * Try and parse out a url by a sub key
 * @param searchKey unique identifyer in the url
 * @param searchStr (optional)
 * @returns {{search: string, filters: Array, sort: string, direction: string}}
 */
const parseSearchQueryByKey = (searchKey, searchStr) => {
    const parsed = getQuery(searchStr);
    let search = '',
        filters = [],
        sort = '',
        direction = '';
    if (parsed && parsed[searchKey]) {
        try {
            const parsedByKey = JSON.parse(parsed[searchKey]);
            search = getSearch(parsedByKey.search);
            filters = getFilters(parsedByKey.search);
            sort = parsedByKey.sort ? parsedByKey.sort : '';
            direction = parsedByKey.direction ? parsedByKey.direction : '';
        } catch (e) {
            console.log('I cannot parse the search query ' + parsed[searchKey]);
        }
    }

    return {search, filters, sort, direction};
};
/**
 * Paired with parseSearchQueryByKey this is used to update that key
 * @param searchKey which key are you targeting
 * @param newQuery this will replace the existing query
 * @param searchStr (optional)
 * @returns {*}
 */
const updateSearchQueryByKey = (searchKey, newQuery, searchStr) => {
    const parsed = getQuery(searchStr);
    if (parsed) {
        if (!parsed[searchKey]) {
            parsed[searchKey] = '';
        }
        parsed[searchKey] = JSON.stringify(newQuery);
    }
    return QueryString.stringify(parsed);
};

export {updateSearchQueryByKey, parseSearchQueryByKey, getFilters};

/**
 * We can pass a search string or grab it from the url
 * parse the query string
 * set all our state values
 */
export default parseSearchQuery;
